import { LocalStorageService } from './../../../core/services/local-storage.service';
import { environment } from './../../../../environment/environment';
import { CandidatService } from './../../../core/services/candidat-service/candidat.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { serverError } from './../../../core/models/messages';
import { SortDataService } from './../../../core/services/sortdata';
import { Country, IState, State } from 'country-state-city';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { translations } from '../../../core/models/call-offer';

@Component({
  selector: 'app-candidaturecalloffer',
  templateUrl: './candidaturecalloffer.component.html',
  styleUrls: ['./candidaturecalloffer.component.css'],
})
export class CandidaturecallofferComponent {
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  stateList!: IState[];
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listcandidats: any;
  urlimage: string = environment.baseUrlGaleryy;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  headerChecked: boolean = false;
  pagination : boolean =false;

  selectedCandidats: any = [];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  searchForm: FormGroup = this.createSearchForm();
  skillsList: { name_FR: string }[] = [];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  currentSortColumn: string = 'name'; // Initial column to sort by
  idoffre = this.activatedRoute.snapshot.params['id'];
  id: any;
  image_url: any;
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private candidatservice: CandidatService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.getListcandidature();
    this.getListSkills();
  }
  getListSkills() {
    this.candidatservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    // let sort={sort:this.currentSortDirection,sortAttribute:item}
    // console.log("sort",sort)
    if (this.searchForm.value != '')
      this.listcandidats = this.sortDataService.sortArray(
        this.listcandidats,
        this.sortAttr,
        this.currentSortDirection
      );
    else this.getListcandidature();
  }
  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCandidature();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListcandidature();
      }
    }
  }
  profilCandidatNavigation(id: any) {
    this.router.navigate(['/profil-candidats', { id: id }]);
  }
  getListcandidature() {
    let dataPyload = {
      id: this.idoffre,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      sort: this.currentSortDirection,
      sortAttribute: 'first_name',
    };
    this.spinner.show();
    this.loadSpinnerTable = true;
    //  let dataPyload =this.sortAttr==''? { job_offer_id: this.idoffre,per_page: this.itemsPerPage, page: this.currentPage}:{ ...{ job_offer_id: this.idclientConnected,per_page: this.itemsPerPage, page: this.currentPage}, ...{sort:this.currentSortDirection,sortAttribute:this.sortAttr} }
    this.candidatservice.getListcandidatureinterne(dataPyload).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listcandidats = response.data.data
          // .slice(0, this.endIndex);
          console.log(' this.listcandidats', this.listcandidats);
          this.image_url = this.listcandidats[0].image_url;

          console.log(' this.image_url', this.image_url);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list candidatures', this.listcandidats);
        }
      },
      error: (error) => {
        console.error('Error fetching salaries: ', error);
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      desired_contract: [[], data?.desired_contract],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      current_country: [null, data?.current_country],
      mobility: [[], data?.mobility],
      availability: [[], data?.availability],
      date_start_candidature: ['', data?.date_start_candidature],
      date_end_candidature: ['', data?.date_end_candidature],
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  /* search */
  searchCandidature() {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(valueForm.desired_salary_range?.toString());
    // let search:string[]=[]
    // search=[valueForm.ID_user,valueForm.availability,valueForm.years_of_experience]
    let data = {
      // sort:this.currentSortDirection,
      // search:search,
      name: valueForm.name,
      search: this.transformSearch(this.searchForm.value.search),
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      years_of_experience: this.searchForm.value.years_of_experience,
      // experience_range:this.searchForm.value.experience_range,
      desired_contract: this.searchForm.value.desired_contract,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      availability: valueForm.availability,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      current_country: valueForm.current_country
        ? valueForm.current_country
        : '',
      mobility: valueForm.city ? valueForm.mobility : '',
      date_start_candidature: valueForm.date_start_candidature,
      date_end_candidature: valueForm.date_end_candidature,
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };
    console.log('data', data);
    this.candidatservice
      .searchCandidatureinterne(this.idoffre, data)
      .subscribe({
        next: (resSearch) => {
          if (this.currentPage > 1) {
            this.currentPage = 1;
            this.searchCandidature();
            console.log('response search', resSearch);
          } else {
            this.listcandidats = resSearch.data.data.slice(0, this.endIndex);
            this.totalItems = resSearch.data.total;
          }
        },
        error: (error) => {
          console.log(error);
          this.toastrService.error(serverError);
        },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  /* change country select and delete the string Governorate from state name*/
  onCountryChange(event: any): void {
    console.log('event', event);
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      // this.addCandidateFormGroup.get('mobility')?.setValue(null)}
    }
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListcandidature();
  }
}
